import { selectExternalInfos } from '@/domain/external/external.selectors';
import { deleteImpactCo2Answer } from '@/domain/impact-co2/actions/delete-impact-co2-answer.action';
import { submitImpactCo2Answer } from '@/domain/impact-co2/actions/submit-impact-co2-answer.action';
import { ImpactCo2Answer } from '@/domain/impact-co2/entities/question.entity';
import { useAppDispatch, useAppSelector } from '@/ui/hook/store';

export function useExternalSubmitAnswer() {
  const dispatch = useAppDispatch();

  const { projectId } = useAppSelector(selectExternalInfos);

  const onSubmit = (answer: ImpactCo2Answer) => {
    dispatch(
      submitImpactCo2Answer({
        answer,
        projectId,
        recalculateAfterSubmit: false,
        submitMode: 'create',
      }),
    );
  };

  const onEdit = (answer: ImpactCo2Answer) => {
    dispatch(
      submitImpactCo2Answer({
        answer,
        projectId,
        recalculateAfterSubmit: false,
        submitMode: 'edit',
      }),
    );
  };

  const onDelete = (answer: ImpactCo2Answer) => {
    dispatch(
      deleteImpactCo2Answer({
        answer,
        projectId,
        recalculateAfterSubmit: false,
      }),
    );
  };

  return { onSubmit, onEdit, onDelete };
}
